module.exports = __webpack_public_path__ + "img/banner-everbright-bank.c7e5ff70.png";